import { FC } from 'react'

import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import { PerformanceProcessTargetHeaderFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'

import { useLayoutContext } from 'modules/layout/hooks/useFullscreen'

export const ReviewProcessTargetHeader: FC<{
  target: PerformanceProcessTargetHeaderFragment
}> = ({ target }) => {
  const { isEmbedded } = useLayoutContext()

  // Hide the header when embedded in mobile WebView
  if (isEmbedded) return null

  return (
    <ResourceHeader
      title={target?.fullName || ''}
      description={target?.employee?.referenceContract?.jobTitle || ''}
      avatar={{
        src: buildUrl(target?.avatar),
        firstName: target?.firstName || '',
        lastName: target?.lastName || '',
        type: 'person',
      }}
    />
  )
}
